import { get } from 'svelte/store';
import type { TranslationFunctions } from '$i18n/i18n-types';
import { idToArea } from './stores';

export function getAreaNameById(LL: TranslationFunctions, id: number) {
  const area = get(idToArea).get(id);
  type Key = keyof TranslationFunctions['er']['areas'];
  return area == undefined ? 'Unknown' : LL.er.areas[area.name as Key]();
}

export function getAreaName(LL: TranslationFunctions, name: string) {
  type Key = keyof TranslationFunctions['er']['areas'];
  return name in LL.er.areas ? LL.er.areas[name as Key]() : 'Unknown';
}
